import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';

type Variables = {
  id: number;
  cancellationReason?: string;
  cancellationReasonDetails?: string;
  refundDestination?: 'credits' | 'card';
};
export type CancelReservationResponse = {
  data: {};
};

export const useCancelReservation = createMutation<
  CancelReservationResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: `v2/reservations/${variables.id}/cancel`,
      method: 'POST',
      data: {
        cancellation_reason: variables.cancellationReason,
        cancellation_reason_details: variables.cancellationReasonDetails,
        refund_destination: variables.refundDestination,
      },
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
